<template>
  <Flicking :options="{  align: 'center' , preventClickOnDrag: true, panelsPerView:2}">
    <div class="pb-18 pt-3 " v-for="(item, i) in thermometerArr.length" :key="item">
      <div class="thermometer">
        <v-slider v-if="readonly||cmplt"
                  v-model="thermometerArrScore[i]"
                  step="10"
                  vertical
                  tick-size="4"
                  class="slider"
                  :color="thermometerArr[i].color"
                  track-color="transparent"
                  readonly
        ></v-slider>
        <v-slider v-else
                  v-model="thermometerArrScore[i]"
                  step="10"
                  vertical
                  tick-size="4"
                  class="slider"
                  :color="thermometerArr[i].color"
                  track-color="transparent"
                  @change="thermometerChange($event, thermometerArr[i].cd)"
        ></v-slider>
        <div class="num-area" :style="{backgroundColor:thermometerArr[i].color}" @click="reset(i)"><span
            class="num">{{ thermometerArrScore[i] }}</span></div>
        <ThermometerIcon/>
        <v-chip :color="thermometerArr[i].color" class="emotion-text">{{ thermometerArr[i].cdNm }}</v-chip>
      </div>
    </div>
  </Flicking>

</template>

<script>
import ThermometerIcon from '@/components/icons/Thermometer'

export default {
  components: {
    ThermometerIcon,
  },
  props: {
    emotionChoiceArr: Array,
    emotionChoiceScoreList: Array,
    readonly: Boolean,
    cmplt: Boolean,
  },
  data: () => ({
    value: 0,
    model: 0,
    total: 3,
    thermometerArr: [0, 0, 0, 0, 0],
    thermometerArrScore: [0, 0, 0, 0, 0]
  }),
  computed: {},
  watch: {},
  mounted() {
    if (this.emotionChoiceArr.length > 0) {
      this.thermometerArr = this.emotionChoiceArr
      this.thermometerArrScore = this.emotionChoiceArr.map(item => item.score)
    }

    if (this.emotionChoiceScoreList.length > 0) {
      this.thermometerArrScore = this.emotionChoiceScoreList
    }
  },
  methods: {
    methodThatForcesUpdate(arr, scoreArr) {
      this.thermometerArr = arr;
      this.thermometerArrScore = scoreArr;
    },
    reset(index) {
      this.thermometerArr[index].value = 0;
    },
    thermometerChange(event, cd) {
      this.$emit('emotionChoice', cd, event);
    }
  }
}
</script>
